module.exports = __webpack_public_path__ + "media/St 4-light switch-hint.45a6da66.wav";